import React, { Component } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import "./dashboard.scss";

const COLORS = ["#1cbb8c", "#fcb92c", "#ff3d60"];
const COLOR_CLASSES = ["text-success", "text-warning", "text-danger"];

const percentsFromCounts = (counts) => {
  const total = counts.reduce((sum, count) => sum + count, 0);
  if (!total) return counts.map(() => 0);
  const raw = counts.map((count) => (count / total) * 100);
  const base = raw.map((value) => Math.floor(value));
  let leftover = 100 - base.reduce((sum, value) => sum + value, 0);
  const order = raw
    .map((value, index) => ({ index, fraction: value - base[index] }))
    .sort((a, b) => b.fraction - a.fraction);
  const result = [...base];
  for (let i = 0; i < leftover; i += 1) {
    result[order[i].index] += 1;
  }
  return result;
};

class SalesAnalytics extends Component {
  state = { monthKey: "" };

  render() {
    const slices = this.props.slices || [];
    const months = this.props.months || [];
    const selected =
      months.find((month) => month.key === this.state.monthKey) || months[0];
    const counts = selected?.counts || slices.map(() => 0);
    const total = counts.reduce((sum, count) => sum + count, 0);
    const percents = percentsFromCounts(counts);
    const labels = slices.map((slice) => slice.label);
    const options = {
      labels,
      plotOptions: {
        pie: {
          donut: {
            size: "75%",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      colors: COLORS,
      tooltip: {
        y: {
          formatter: (value) => `${value} reservation${value === 1 ? "" : "s"}`,
        },
      },
    };

    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <div className="float-end">
              <select
                className="form-select form-select-sm"
                value={selected?.key || ""}
                onChange={(event) =>
                  this.setState({ monthKey: event.target.value })
                }
              >
                {months.map((month) => (
                  <option key={month.key} value={month.key}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
            <h4 className="card-title mb-4">Sales Analytics</h4>

            <div id="donut-chart" className="apex-charts">
              {total > 0 ? (
                <ReactApexChart
                  key={selected?.key}
                  options={options}
                  series={counts}
                  type="donut"
                  height="250"
                />
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center text-muted"
                  style={{ height: 250 }}
                >
                  No reservations this month
                </div>
              )}
            </div>

            <Row>
              {labels.map((label, index) => (
                <Col xs={4} key={label}>
                  <div className="text-center mt-4">
                    <p className="mb-2 text-truncate">
                      <i
                        className={`mdi mdi-circle ${COLOR_CLASSES[index]} font-size-10 me-1`}
                      ></i>{" "}
                      {label}
                    </p>
                    <h5>{percents[index] || 0} %</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default SalesAnalytics;
